var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Upload,{ref:"uploadRef",attrs:{"state-key":_vm.stateKey,"http-rrequest":_setup.handleHttpRrequest,"before-delete-file":_setup.handleBeforeDeleteFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }